import { render, staticRenderFns } from "./ProofManagement.vue?vue&type=template&id=5483a589&scoped=true&"
import script from "./ProofManagement.vue?vue&type=script&lang=js&"
export * from "./ProofManagement.vue?vue&type=script&lang=js&"
import style0 from "./ProofManagement.vue?vue&type=style&index=0&id=5483a589&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5483a589",
  null
  
)

export default component.exports